import React from 'react';
import { Immutable } from 'nuclear-js';
import icons from 'glyphicons';
import CommonValues from 'resources/common-values';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';

import IAUtils from '../utils';

export default CreateReactClass({
    displayName: 'SubAreaAndGroupFilter',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        studentInfo: PropTypes.instanceOf(Immutable.List),
        lcStatements: PropTypes.instanceOf(Immutable.List),
        selectedGoals: PropTypes.instanceOf(Immutable.List),
        selectedSubGoal: PropTypes.string,
        selectSubGoal: PropTypes.func.isRequired,
        selectedTopicOrStandard: PropTypes.string.isRequired,
        selectTopicOrStandard: PropTypes.func.isRequired,
        groupBy: PropTypes.string,
    },

    getInitialState() {
        return {
            showIcon: false,
            showFilters: false,
            subareaDropdownOpen: false,
            groupDropdownOpen: false,
        };
    },

    UNSAFE_componentWillMount() {
        if (this.shouldIconShow(this.props.selectedGoals)) {
            this.setState({
                showIcon: true,
            });
        }
    },

    componentDidMount() {
        window.addEventListener('keyup', this.onKeyUp);
    },

    componentWillUnmount: function() {
        window.removeEventListener('keyup', this.onKeyUp);
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        const showIcon = this.shouldIconShow(nextProps.selectedGoals);
        const showFilters = showIcon && this.state.showFilters;
        const subareaDropdownOpen = showIcon && showFilters && this.state.subareaDropdownOpen;
        const groupDropdownOpen = showIcon && showFilters && this.state.groupDropdownOpen;

        if (showIcon !== this.state.showIcon || showFilters !== this.state.showFilters) {
            this.setState({
                showIcon,
                showFilters,
                subareaDropdownOpen,
                groupDropdownOpen,
            });
        }

        if (!Immutable.is(this.props.selectedGoals, nextProps.selectedGoals)) {
            this.props.selectSubGoal('All');
            this.props.selectTopicOrStandard('All');
        }
    },

    shouldIconShow(selectedGoals) {
        return selectedGoals && selectedGoals.size === 1;
    },

    onKeyUp(event) {
        if (event.code === 'Escape') {
            if (this.state.subareaDropdownOpen) {
                this.toggleSubareaDropdown();
            }
            if (this.state.groupDropdownOpen) {
                this.toggleGroupDropdown();
            }
        }
    },

    toggleFilters() {
        Analytics.recordButtonClick(
            CommonValues.SectionIDs.instructionalAreas,
            'filters',
            this.state.showFilters ? 'open' : 'close'
        );
        this.setState({ showFilters: !this.state.showFilters });
    },

    toggleSubareaDropdown() {
        this.setState({ subareaDropdownOpen: !this.state.subareaDropdownOpen });
    },

    toggleGroupDropdown() {
        this.setState({ groupDropdownOpen: !this.state.groupDropdownOpen });
    },

    changeSubGoal(subgoalName) {
        //TODO: expand chevron
        if (subgoalName !== this.props.selectedSubGoal) {
            this.props.selectSubGoal(subgoalName);
            this.props.selectTopicOrStandard('All');
            // give the DOM components time to render
            setTimeout(() => IAUtils.expandChevrons(), 1);
        }
        this.toggleSubareaDropdown();
    },

    changeGroup(groupName) {
        if (groupName !== this.props.selectedTopicOrStandard) {
            this.props.selectTopicOrStandard(groupName);
            // give the DOM components time to render
            setTimeout(() => IAUtils.expandChevrons(), 1);
        }
        this.toggleGroupDropdown();
    },

    getStudentName() {
        const defaultName = 'this student';
        if (this.props.studentInfo && !this.props.studentInfo.isEmpty()) {
            return this.props.studentInfo.maxBy((si) => si.get('termNumber')).get('firstName', defaultName);
        }

        return defaultName;
    },

    filteredStatementsByGoal() {
        if (this.props.lcStatements && this.props.selectedGoals) {
            const goalkeys = this.props.selectedGoals.map((g) => g.get('goalkey'));
            return this.props.lcStatements.filter((s) => goalkeys.includes(s.get('goalkey')));
        }

        return null;
    },

    findSubgoals() {
        const statementsByGoal = this.filteredStatementsByGoal();
        return statementsByGoal
            ? statementsByGoal
                  .groupBy((s) =>
                      Immutable.Map.of('subgoalId', s.get('subgoalId'), 'subgoalName', s.get('subgoalName'))
                  )
                  .sortBy((val, key) => key.get('subgoalName'))
            : null;
    },

    findGroups() {
        const bySubgoals = this.findSubgoals();
        const byGroups = bySubgoals
            ? bySubgoals.map((statementsForSubgoal) => {
                  return statementsForSubgoal
                      .groupBy((s) =>
                          Immutable.Map.of(
                              'groupId',
                              s.get('groupId'),
                              'groupDesc',
                              s.get('groupDesc'),
                              'groupSortOrder',
                              s.get('groupSortOrder')
                          )
                      )
                      .sortBy((val, key) => key.get('groupSortOrder'));
              })
            : null;
        return byGroups;
    },

    renderDropdown(name, value, items, toggleFunction, isOpenFunction) {
        const openClass = isOpenFunction() ? 'open' : '';
        const button = (
            <button key={`button-${name}`} value={value} title={value} onClick={toggleFunction}>
                <span key="value">{value}</span>
                <span key="caret" className="caret">
                    {icons.arrowTriD}
                </span>
            </button>
        );
        const list = (
            <ul key={`list-${name}`} className={openClass}>
                {items}
            </ul>
        );
        const overlay = <div key={`overlay-${name}`} className={`overlay ${openClass}`} onClick={toggleFunction} />;
        let className =
            this.props.groupBy === CommonValues.StandardTypes.descartes.storeValue && name === 'group'
                ? 'hide'
                : 'sub-area-dropdown';

        return (
            <div key={`dropdown-${name}`} className={className}>
                {button}
                {list}
                {overlay}
            </div>
        );
    },

    renderSubgoalDropdown(subgoalMap) {
        const value = this.props.selectedSubGoal;
        const isOpen = () => this.state.subareaDropdownOpen;

        const items = [
            <li key="all" onClick={() => this.changeSubGoal('All')} className="all">
                All
            </li>,
        ];
        const subgoals = subgoalMap ? subgoalMap.keySeq() : null;
        if (subgoals) {
            subgoals.forEach((s) => {
                items.push(
                    <li
                        key={s.get('subgoalId')}
                        className="subgoal-item"
                        onClick={() => this.changeSubGoal(s.get('subgoalName'))}
                    >
                        {s.get('subgoalName')}
                    </li>
                );
            });
        }

        return this.renderDropdown('subgoal', value, items, this.toggleSubareaDropdown, isOpen);
    },

    renderGroupDropdown(groups) {
        const value = this.props.selectedTopicOrStandard;
        const isOpen = () => this.state.groupDropdownOpen;
        const items = [
            <li
                key="All"
                onClick={() => {
                    this.changeGroup('All');
                }}
                className="all"
            >
                All
            </li>,
        ];

        if (groups) {
            groups.forEach((statementsForSubgoal, subgoal) => {
                items.push(
                    <li key={`subgoal-${subgoal.get('subgoalId')}`} className="subgoal-header">
                        {subgoal.get('subgoalName')}
                    </li>
                );
                statementsForSubgoal.forEach((statementsForGroup, group) => {
                    items.push(
                        <li
                            key={`group-${group.get('groupId')}-subgoal-${subgoal.get('subgoalId')}`}
                            onClick={() => this.changeGroup(group.get('groupDesc'))}
                            className="group"
                        >
                            {group.get('groupDesc')}
                        </li>
                    );
                });
            });
        }

        return this.renderDropdown('group', value, items, this.toggleGroupDropdown, isOpen);
    },

    render() {
        const idSuffix = `for-subject-${this.props.subject.get('bid')}`;
        const subgoals = this.findSubgoals();
        const groups = this.findGroups();

        const showFilter = this.state.showFilters ? ' show-filters' : '';
        const showIcon = this.state.showIcon ? ' show-icon' : '';
        const filterIconId = `ls-filter-${this.props.subject.get('bid')}`;

        return (
            <div className={`sub-area-group-filter${showFilter}${showIcon}`}>
                <span key="start-text" className="start-text">
                    These learning statements apply to {this.getStudentName()}'s current RIT score:
                </span>
                <span key="sub-area-filter" id={filterIconId} onClick={this.toggleFilters} className="filter-icon" />
                <label key="sub-area-filter-label" className="filter-icon-label" htmlFor={filterIconId}>
                    Filters
                </label>
                <label
                    key="sub-areas-label"
                    className={
                        this.props.groupBy === CommonValues.StandardTypes.descartes.storeValue
                            ? 'hide-group ' + (this.state.showFilters ? 'show-fade' : 'hide-fade')
                            : 'sub-areas-label'
                    }
                    htmlFor={`sub-area-select-${idSuffix}`}
                >
                    Show instructional sub-areas:
                </label>
                <label
                    key="grouping-label"
                    className={
                        this.props.groupBy === CommonValues.StandardTypes.descartes.storeValue
                            ? 'hide'
                            : 'sub-areas-label'
                    }
                    htmlFor={`grouping-select-${idSuffix}`}
                >
                    Show {this.props.groupBy}:
                </label>
                {this.renderSubgoalDropdown(subgoals)}
                {this.renderGroupDropdown(groups)}
            </div>
        );
    },
});
